import { Tooltip } from "@mui/material";
import React from "react";
import EABadge from "../Badge/EABadge";

interface IProps {
  title: string;
  variant?: "filled" | "outlined" | "icon";
  color?: "primary" | "secondary";
  onClick?: () => void;
  icon: React.ReactNode;
  disabled?: boolean;
  badgeValue?: string | number;
  compact?: boolean;
  onDisabledClick?: () => void;
}

const EAIconButton: React.FC<IProps> = ({
  title,
  variant = "filled",
  color = "primary",
  onClick = () => {},
  icon,
  disabled,
  badgeValue = "",
  compact = false,
  onDisabledClick,
}) => {
  return (
    <Tooltip title={title}>
      <span style={{ position: "relative", display: "inline-block" }}>
        <button
          className={`icon-button icon-button--${variant} icon-button--${color} ${
            compact ? "icon-button-compact" : ""
          }`}
          onClick={onClick}
          disabled={disabled}
        >
          <EABadge value={badgeValue}>
            <span className="icon-button-icon">{icon}</span>
          </EABadge>
        </button>

        {/* Niewidoczna nakładka dla disabled button z onDisabledClick */}
        {disabled && onDisabledClick && (
          <div
            onClick={onDisabledClick}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              cursor: "pointer",
              zIndex: 1,
            }}
          />
        )}
      </span>
    </Tooltip>
  );
};

export default EAIconButton;
